import {
  ActivityType,
  activityTypes,
  CalculatedAreaActivityType,
  calculatedAreaActivityTypes,
  OtherActivityType,
  otherActivityTypes,
  ProgramActivityType,
  programActivityTypes,
} from '@shared/models/design/activities/activity-type.model';
import { ActivityReference } from '@shared/models/design/storey.model';
import { Replace } from '@shared/models/type-helpers.model';

const isActivityType = (type?: unknown): type is ActivityType =>
  activityTypes.includes(type as ActivityType);

const isCalculatedAreaActivityType = (
  type?: unknown,
): type is CalculatedAreaActivityType =>
  calculatedAreaActivityTypes.includes(type as CalculatedAreaActivityType);
// Calculated activity references should stay untouched by share redistribution.

const isCalculatedAreaActivityRef = (
  ref: ActivityReference,
): ref is Replace<ActivityReference, { type: CalculatedAreaActivityType }> =>
  isCalculatedAreaActivityType(ref.type);

const isProgramActivityType = (type?: unknown): type is ProgramActivityType =>
  programActivityTypes.includes(type as ProgramActivityType);

const isProgramActivityRef = (
  ref: ActivityReference,
): ref is Replace<ActivityReference, { type: ProgramActivityType }> =>
  isProgramActivityType(ref.type);

const isOtherActivityType = (type?: unknown): type is OtherActivityType =>
  otherActivityTypes.includes(type as OtherActivityType);

const isOtherActivityRef = (
  ref: ActivityReference,
): ref is Replace<ActivityReference, { type: OtherActivityType }> =>
  isOtherActivityType(ref.type);

export const activityRefGuards = {
  is: {
    calculatedAreaActivityType: isCalculatedAreaActivityType,
    calculatedAreaActivityRef: isCalculatedAreaActivityRef,
    programActivityType: isProgramActivityType,
    programActivityRef: isProgramActivityRef,
    otherActivityType: isOtherActivityType,
    otherActivityRef: isOtherActivityRef,
    activityType: isActivityType,
  },
} as const;
